import moment from "moment-timezone";

const baseUrl = `https://ms-ezypowerups-board2export-cucbd0e7ekgsgkf3.centralus-01.azurewebsites.net/`;

export const getClientByEmail = async (email, token) => {
  const url = `${baseUrl}clientes/assinaturas?email=${encodeURIComponent(
    email
  )}`;
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(token),
    };

    const response = await fetch(url, requestOptions);

    if (!response?.ok) {
      throw new Error("Erro ao obter os dados:", response.status);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    error.url = url;
    throw error;
  }
};

export const createClientOnEzDB = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  fetch(baseUrl + "clientes", requestOptions)
    .then((response) => {
      if (!response.ok) {
        //console.error("Erro ao enviar os dados:", response.status);
      }
      return response.json();
    })
    .then((result) => {
      // console.log("Resposta:", result);
    })
    .catch((error) => {
      error.url = baseUrl + "clientes";
      throw new Error("Ocorreu um erro: " + error.message);
    });
};

export const getPlans = async () => {
  const url = `${baseUrl}planos`;
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response?.ok) {
      throw new Error("Erro na busca dos prompts: " + response.status);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    error.url = url;
    throw new Error("Erro na busca dos prompts: " + error.message);
  }
};

export async function createErrorLog(erro) {
  const REACT_APP_ERROR_API_URL =
    "https://prod-21.northcentralus.logic.azure.com:443/workflows/8bfec99b659d4b0d9c5b2e5194bf96a0/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=d8_gDERBu9OT9u9uBZI-yMY5FEcfx97IjjiGKMqQfgU";

  try {
    const data = {
      produto: "EzyBoard2Export",
      tx_erro_menssage: erro.message,
      tx_error_tracer: JSON.stringify(erro.tracer),
      tx_email_cliente: erro.email,
      tx_endpoint_error: erro.url,
    };

    const response = await fetch(REACT_APP_ERROR_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error response from server: ${errorText}`);
    }
  } catch (error) {
    throw new Error("Error creating error log");
  }
}

export const getSchedules = async () => {
  const url = `${baseUrl}escala`;
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response?.ok) {
      throw new Error("Erro na busca das escalas: " + response.status);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    error.url = url;
    throw new Error("Erro na busca das escalas: " + error.message);
  }
};

export const createSchedule = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(baseUrl + "agenda", requestOptions);

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(
        `Erro ao criar agendamento: ${response.status} - ${errorMessage}`
      );
    }

    return await response.json();
  } catch (error) {
    error.url = baseUrl + "agenda";
    throw new Error(`Ocorreu um erro: ${error.message}`);
  }
};

export const deleteSchedule = async (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}agenda/${id}`, requestOptions);
    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(`Erro ao deletar o agendamento: ${errorMessage}`);
    }
  } catch (error) {
    error.url = baseUrl + "agenda";
    throw new Error(`Erro na requisição: ${error.message}`);
  }
};

export const getTimeZones = async () => {
  const url = `${baseUrl}timezone`;
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response?.ok) {
      throw new Error("Erro na busca dos timezones: " + response.status);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    error.url = url;
    throw new Error("Erro na busca dos timezones: " + error.message);
  }
};

export const getExports = async (email, month, year) => {
  const url = `${baseUrl}clientes/exportacoes?email=${email}&mes=${month}&ano=${year}`;
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(url, requestOptions);

    if (!response?.ok) {
      throw new Error("Erro na busca das exportações: " + response.status);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    error.url = url;
    throw new Error("Erro na busca das exportações: " + error.message);
  }
};

export const getFileToDownload = async (id) => {
  const url = `${baseUrl}exportacao/${id}`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);

    const responseData = await response.json();
    return responseData;
  } catch (err) {
    console.error("Erro ao obter o arquivo:", err.message);
    return {};
  }
};

export const exportFileToDownload = async ({
  textEmail,
  textBoardId,
  nameBoard,
  typeExportacao,
  body,
}) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dataAtual = moment().tz(userTimezone).format("YYYY-MM-DD HH:mm:ss");
  const url = `${baseUrl}exportacao?textEmail=${textEmail}&textBoardId=${textBoardId}&nameBoard=${nameBoard}&typeExportacao=${typeExportacao}&date=${dataAtual}`;

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok)
      throw new Error(`Status: ${response.status}, ${await response.text()}`);

    const responseData = await response.json();
    return responseData;
  } catch (err) {
    console.error("Erro ao obter o arquivo:", err.message);
    return {};
  }
};
